// extracted by mini-css-extract-plugin
export default {"checkbox":"DeleteCoachForm_checkbox__u+Yd6","checkboxText":"DeleteCoachForm_checkboxText__ERFcq"};